import { create, object, string } from "superstruct";

const PLATFORM_ORIGIN = import.meta.env.VITE_PLATFORM_ORIGIN;
const SERVICES_ORIGIN = import.meta.env.VITE_SERVICES_ORIGIN;

const envAsAny = {
    PLATFORM_ORIGIN,
    SERVICES_ORIGIN,
} as unknown;

const env = create(
    envAsAny,
    object({
        PLATFORM_ORIGIN: string(),
        SERVICES_ORIGIN: string(),
    }),
);

export default env;
